import BandeiraModel from "@/models/financeiro/bandeiraModel";

import { IService } from "./../base/iService";

export default class BandeiraService extends IService<BandeiraModel> {
    constructor() {
        super("Bandeira");
    }
}
